import { render, staticRenderFns } from "./SDSubStatusAdd.vue?vue&type=template&id=9c6bb1ce&scoped=true"
import script from "./SDSubStatusAdd.vue?vue&type=script&lang=js"
export * from "./SDSubStatusAdd.vue?vue&type=script&lang=js"
import style0 from "./SDSubStatusAdd.vue?vue&type=style&index=0&id=9c6bb1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6bb1ce",
  null
  
)

export default component.exports